import React, {Component} from "react";
import './tooltips.css';
class ToolTips extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            timeout: ''
        };
    }
    showTip = () => {
        this.state.timeout = setTimeout(() => {
            this.setState({
                active: true
            })
        }, this.props.delay || 400);
    };

    hideTip = () => {
        clearInterval(this.state.timeout);
        this.setState({
            active: false
        })
    };
    render() {
        return (
            <div className={`tooltip-wrapper ${this.props.data}`} onMouseEnter={() => this.showTip()} onMouseLeave={() => this.hideTip()}>
                {this.props.children}
                {this.state.active && (
                    <div className="tooltip-tip">
                        {this.props.content}
                    </div>
                )}
            </div>
        );
    }
}


export default ToolTips;
